// Reading a date that may be UK text (B-S1, B-S2, Mohammed's decision 2026-11-02).
//
// The backend sends dates as text: "05/10/2026" or "05/10/2026 14:30". moment() given that text with
// no format falls back to the browser's Date, which reads it the American way: 10 May. Written
// out again it became "10/05/2026" and was stored, so an edit with nothing changed swapped day and
// month whenever the day was 12 or under. A day over 12 came back "Invalid date" and escaped.
//
// So text that looks like a UK date is read day first and strictly. Anything else (a Date the
// user picked on a Calendar, ISO text, no value at all) goes to moment() exactly as before. Like
// moment(), it reads in the browser's local time and converts nothing, so the day does not shift.

import moment from 'moment'

const LOOKS_UK = /^\s*\d{1,2}\/\d{1,2}\/\d{4}(\s|$)/
const UK_FORMATS = ['DD/MM/YYYY', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY HH:mm:ss', 'D/M/YYYY', 'D/M/YYYY H:mm', 'D/M/YYYY H:mm:ss']

export function readUkDate(value) {
  if (typeof value === 'string' && LOOKS_UK.test(value)) {
    return moment(value.trim(), UK_FORMATS, true)
  }
  return moment(value)
}
